module.exports = __webpack_public_path__ + "static/2021-06-17-14-52-55-859-fs8-27e976734769b8d02c3f6cdd7056daa7.png";